(function (root, factory) {
	// eslint-disable-next-line no-undef
	if (typeof define === "function" && define.amd) {
		define([], function () {
			return factory(root);
		});
	} else if (typeof exports === "object") {
		module.exports = factory(root);
	} else {
		root.AccordionTabs = factory(root);
	}
})(
	// eslint-disable-next-line no-nested-ternary
	typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : this,
	function (window) {
		// Use strict mode

		// Create an empty plugin object
		const plugin = {};

		// Set the plugin defaults
		const defaults = {
			// Accordion parts
			accordionClass: "accordion-tabs",
			headerClass: "accordion-tabs__title",
			contentClass: "accordion-tabs__content",
			panelClass: "accordion-tabs__panel",

			// Toggle Button
			toggleBtnClass: "accordion-tabs__toggle",

			// Icons
			icons: true,
			iconsSymbol: "plus-minus", // arrow
			iconsPosition: "left", // right

			// Expand All features
			expandAllBtn: true,
			expandAllClass: "accordion__toggle-all",
			expandAllContainerClass: "accordion__toggle-all-container",
			expandSelectClass: "expanded",
			expandAllOpenText: "Expand All",
			expandAllCloseText: "Collapse All",
			expanded: false, // expanded or collapsed by default

			//
			view: getView()
		};

		/*!
		 * Deep merge two or more objects into the first.
		 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
		 * @param   {Object} objects  The objects to merge together
		 * @returns {Object}          Merged values of defaults and options
		 */
		const deepMerge = function () {
			// Make sure there are objects to merge
			const len = arguments.length;
			if (len < 1) return;
			if (len < 2) return arguments[0];

			// Merge all objects into first
			for (let i = 1; i < len; i++) {
				for (const key in arguments[i]) {
					// If it's an object, recursively merge
					// Otherwise, push to key
					if (Object.prototype.toString.call(arguments[i][key]) === "[object Object]") {
						arguments[0][key] = deepMerge(arguments[0][key] || {}, arguments[i][key]);
					} else {
						arguments[0][key] = arguments[i][key];
					}
				}
			}

			return arguments[0];
		};

		/**
		 * Constructor.
		 * @param  {String}  element  The selector element(s).
		 * @param  {Object}   options  The plugin options.
		 * @return {void}
		 */
		function Plugin(element, options) {
			// Set the plugin object
			plugin.this = this;
			plugin.element = element;
			plugin.defaults = defaults;
			plugin.options = options;
			// Merge user settings with defaults
			plugin.settings = deepMerge(defaults, options);

			// Initialize the plugin
			plugin.this.init();
			setView();
		}

		//
		// Methods
		//

		function getView() {
			return window.matchMedia("(max-width: 1023px)").matches ? "mobile" : "desktop";
		}

		function setView() {
			// Query for the initial page load
			var tempMedia;
			// Store the window width
			let windowWidth = window.innerWidth;

			window.addEventListener("resize", function () {
				tempMedia = getView();
				// Check window width has actually changed and it's not just iOS triggering a resize event on scroll
				if (window.innerWidth != windowWidth) {
					// Update the window width for next time
					windowWidth = window.innerWidth;

					if (tempMedia == "mobile") {
						mobileSetup();
					} else if (tempMedia == "desktop") {
						const accordionPanels = document.querySelectorAll(`.${plugin.settings.panelClass}`);
						Array.prototype.forEach.call(accordionPanels, function (accordionPanel) {
							accordionPanel.removeAttribute("style");
						});
					}
					if (plugin.settings.view !== tempMedia) {
						plugin.settings.view = tempMedia;
					}
				}
			});
		}

		function currentAccordion() {
			const accordions = document.querySelector(".accordion-tabs");
			let selectedToggle = accordions.querySelector("[aria-expanded='true']");
			let selectedPanel = accordions.querySelector("[aria-hidden='false']");
			return { selectedToggle, selectedPanel };
		}

		/**
		 * If icon is true then create and setup icon
		 *
		 * @function accordionIconSetup
		 * @param  {String} toggle The toggle button
		 * @return {void}
		 */
		const accordionIconSetup = function (toggle) {
			const toggleBtn = toggle;
			if (plugin.settings.icons === true) {
				const iconContainer = document.createElement("span");
				iconContainer.classList.add(plugin.settings.iconsSymbol);
				iconContainer.classList.add(plugin.settings.iconsPosition);
				toggle.appendChild(iconContainer);
			} else {
				toggleBtn.classList.add("hidden-icon");
			}
		};

		/**
		 * Setup plugin.settings.panelClass which contains the content
		 *
		 * @function accordionContentSetup
		 * @param  {String} content The accordion container.
		 * @param  {String} id The accordion id.
		 * @return {void}
		 */
		const accordionContentSetup = function (header, id) {
			// Get accordion content from plugin.settings.accordionClass container
			const accordionPanel = header.nextElementSibling;
			// Create div for accordion content add content class
			const accordionContent = document.createElement("div");
			accordionContent.className = plugin.settings.contentClass;
			// Add content from panel
			accordionContent.innerHTML = accordionPanel.innerHTML;

			// Clear accordion panel html since it was added to content div
			accordionPanel.innerHTML = "";
			// Append content div to accordion panel
			accordionPanel.appendChild(accordionContent);

			accordionPanel.setAttribute("id", `accordion${id}`);

			// Check to see if the accordions are set to be expanded or collapsed
			if (plugin.settings.expanded === false) {
				accordionPanel.setAttribute("aria-hidden", "true");
				accordionPanel.setAttribute("tabindex", "-1");
			} else {
				accordionPanel.setAttribute("aria-hidden", "false");
			}

			if (plugin.settings.view === "mobile") {
				mobileSetup();
			}
		};

		/**
		 * Setup plugin.settings.toggleBtnClass, the individual accordion toggle button
		 *
		 * @function accordionToggleSetup
		 * @param  {String} content The accordion button.
		 * @param  {String} btnId The accordion button id.
		 *
		 */
		const accordionToggleSetup = function (header, btnId) {
			// Get accordion header from plugin.settings.accordionClass
			const accordionHeader = header;

			// Create a toggle button, add toggle class and aria attributes
			const toggle = document.createElement("button");
			toggle.className = plugin.settings.toggleBtnClass;
			toggle.setAttribute("aria-controls", `accordion${btnId}`);
			// Check to see if the accordions are set to be expanded or collapsed
			if (plugin.settings.expanded === false) {
				toggle.setAttribute("aria-expanded", "false");
			} else {
				toggle.setAttribute("aria-expanded", "true");
			}

			// Get content from existing header and add to button
			toggle.innerHTML = accordionHeader.innerHTML;

			// Clear accordion header html since it was added to button
			accordionHeader.innerHTML = "";
			// Append button to accordion header
			accordionHeader.appendChild(toggle);

			// Initialize the accordion content and icon
			accordionContentSetup(header, btnId);
			accordionIconSetup(toggle);
		};

		const mobileSetup = function () {
			const accordionPanels = document.querySelectorAll(`.${plugin.settings.panelClass}`);
			const accordionToggles = document.querySelectorAll(`.${plugin.settings.toggleBtnClass}`);

			Array.prototype.forEach.call(accordionPanels, function (accordionPanel) {
				if (plugin.settings.expanded === false) {
					accordionPanel.style.height = "0px";
					accordionPanel.setAttribute("aria-hidden", "true");
				} else {
					accordionPanel.style.height = `${accordionPanel.scrollHeight}px`;
				}
			});
			Array.prototype.forEach.call(accordionToggles, function (accordionToggle) {
				accordionToggle.setAttribute("aria-expanded", "false");
			});
		};

		/**
		 * Create and setup plugin.settings.expandAllClass
		 *
		 * @function toggleAllSetup
		 * @return {void}
		 */
		const toggleAllSetup = function () {
			// find first accodrion if only one the return
			const firstAccordion = document.querySelector(`.${plugin.settings.accordionClass}`);

			if (!firstAccordion) return;

			// create button container
			const buttonContainer = document.createElement("div");
			buttonContainer.className = plugin.settings.expandAllContainerClass;

			// create expand all button
			const button = document.createElement("button");
			button.className = plugin.settings.expandAllClass;
			// Check to see if the accordions are set to be expanded or collapsed
			if (plugin.settings.expanded === false) {
				button.setAttribute("aria-expanded", "false");
				button.textContent = plugin.settings.expandAllOpenText;
			} else {
				button.setAttribute("aria-expanded", "true");
				button.textContent = plugin.settings.expandAllCloseText;
			}

			// insert button into container
			buttonContainer.appendChild(button);

			// find parent element of first accordion
			const parentContainer = firstAccordion.parentNode;

			// insert button container before first accordion
			parentContainer.insertBefore(buttonContainer, firstAccordion);
		};

		/**
		 *
		 *
		 * @function toggleButton
		 * @param  {String} targetElem  The toggle button
		 * @param  {String} direction   The direction of the accordion Expand/Collapse
		 * @return {void}
		 */
		const toggleButton = function (targetElem, direction) {
			const activeAccordion = currentAccordion();
			if (activeAccordion.selectedToggle) {
				activeAccordion.selectedToggle.setAttribute("aria-expanded", false);
			}
			if (direction === "expand") {
				targetElem.setAttribute("aria-expanded", "true");
			} else {
				targetElem.setAttribute("aria-expanded", "false");
			}
		};

		/**
		 * @function toggleContent
		 * @param  {String} targetElem The Accordion button
		 * @param  {MouseEvent} event mouse or keyboard
		 * @param  {String} direction The direction of the accordion Expand/Collapse
		 * @return {void}
		 */
		const toggleAccordion = function (targetElem, event, direction) {
			if (targetElem.getAttribute("aria-hidden") === true) return;
			const controls = targetElem.getAttribute("aria-controls");
			const controlsElem = document.getElementById(controls);
			const controlsElemChild = controlsElem.firstElementChild;
			const controlsElemHeight = controlsElem.scrollHeight;
			const toggled = controlsElem.getAttribute("aria-hidden");

			if (event) {
				event.preventDefault();
			}

			const activeAccordion = currentAccordion();
			if (activeAccordion.selectedPanel) {
				const activeAccordionChild = activeAccordion.selectedPanel.firstElementChild;
				activeAccordion.selectedPanel.setAttribute("aria-hidden", true);
				setTimeout(function () {
					activeAccordionChild.style.height = "0";
				}, 300);
			}

			if (direction === "expand" && toggled === "true") {
				controlsElemChild.style.height = "auto";
				setTimeout(function () {
					controlsElem.setAttribute("aria-hidden", "false");
				}, 300);
			} else if (direction === "collapse" && toggled === "false") {
				controlsElem.setAttribute("aria-hidden", "true");
				setTimeout(function () {
					controlsElemChild.style.height = "0";
				}, 300);
			}

			toggleButton(targetElem, direction);
		};
		const toggleAccordionMobile = function (targetElem, event, direction) {
			const controls = targetElem.getAttribute("aria-controls");
			const controlsElem = document.getElementById(controls);
			const controlsElemHeight = controlsElem.scrollHeight;
			const toggled = controlsElem.getAttribute("aria-hidden");

			if (event) {
				event.preventDefault();
			}

			function timeoutSet(element) {
				setTimeout(function () {
					element.style.height = "auto";
				}, 300);
			}

			// const activeAccordion = currentAccordion();
			// if (activeAccordion.selectedPanel) {
			// 	activeAccordion.selectedPanel.style.height = `${controlsElem.scrollHeight}px`;
			// 	activeAccordion.selectedPanel.setAttribute("aria-hidden", "true");
			// 	setTimeout(function () {
			// 		activeAccordion.selectedPanel.style.height = `${0}px`;
			// 	}, 50);
			// }

			if (direction === "expand" && toggled === "true") {
				controlsElem.style.height = `${controlsElemHeight}px`;
				controlsElem.setAttribute("aria-hidden", "false");
				timeoutSet(controlsElem);
			} else if (direction === "collapse" && toggled === "false") {
				controlsElem.style.height = `${controlsElem.scrollHeight}px`;
				controlsElem.setAttribute("aria-hidden", "true");
				setTimeout(function () {
					controlsElem.style.height = `${0}px`;
				}, 50);
			}

			toggleButton(targetElem, direction);
		};

		/**
		 * @function toggleAllContent
		 * @param  {String} targetElem The toggle all button
		 * @param  {MouseEvent} event mouse or keyboard
		 * @param  {String} direction The direction of the accordion Expand/Collapse
		 * @return {void}
		 */
		const toggleAllAccordions = function (targetElem, event, direction) {
			if (event) {
				event.preventDefault();
			}

			// Grab all accordion toggles in the document
			const buttons = document.querySelectorAll(`.${plugin.settings.toggleBtnClass}`);
			// Loop through each accordion
			Array.prototype.forEach.call(buttons, function (button) {
				toggleAccordion(button, event, direction);
			});

			// After event toggle aria-expanded attribute
			targetElem.setAttribute("aria-expanded", targetElem.getAttribute("aria-expanded") === "true" ? "false" : "true");

			// After event toggle button text
			targetElem.textContent =
				targetElem.textContent === plugin.settings.expandAllOpenText
					? (targetElem.textContent = plugin.settings.expandAllCloseText)
					: (targetElem.textContent = plugin.settings.expandAllOpenText);
		};

		/**
		 * @function clickHandler
		 * @param  {String} event mouse click
		 * @return {type} {description}
		 */
		const clickHandler = function (event) {
			const toggleBtn = event.target.closest(`.${plugin.settings.toggleBtnClass}`);
			const toggleAll = event.target.closest(`.${plugin.settings.expandAllClass}`);

			const direction = event.target.getAttribute("aria-expanded") === "true" ? "collapse" : "expand";

			if (toggleBtn && plugin.settings.view === "desktop") {
				toggleAccordion(toggleBtn, event, direction);
			} else if (toggleBtn && plugin.settings.view === "mobile") {
				toggleAccordionMobile(toggleBtn, event, direction);
			}
			if (toggleAll) {
				toggleAllAccordions(toggleAll, event, direction);
			}
		};
		/**
		 * @function keyboardHandler
		 * @param  {String} event keyboard press
		 * @return {type} {description}
		 */
		const keyboardHandler = function (event) {
			if (event.key == "Enter" || event.key == " ") {
				const toggleBtn = event.target.closest(`.${plugin.settings.toggleBtnClass}`);
				const toggleAll = event.target.closest(`.${plugin.settings.expandAllClass}`);
				const direction = event.target.getAttribute("aria-expanded") === "true" ? "collapse" : "expand";

				if (toggleBtn && plugin.settings.view === "desktop") {
					toggleAccordion(toggleBtn, event, direction);
				} else if (toggleBtn && plugin.settings.view === "mobile") {
					toggleAccordionMobile(toggleBtn, event, direction);
				}
				if (toggleAll) {
					toggleAllAccordions(toggleAll, event, direction);
				}
			}
		};

		/**
		 * Public variables and methods.
		 * @type {object}
		 */
		Plugin.prototype = {
			setup() {
				const accordionHeaders = document.querySelectorAll(`.${plugin.settings.headerClass}`);
				let btnId = 0;
				Array.prototype.forEach.call(accordionHeaders, function (accordionHeader) {
					btnId += 1;
					accordionToggleSetup(accordionHeader, btnId);
				});
				const ariaHidden = document.querySelectorAll(`.${plugin.settings.accordionClass} [aria-hidden]`);
				const ariaExpanded = document.querySelectorAll(`.${plugin.settings.accordionClass} [aria-expanded]`);

				if (ariaHidden && plugin.settings.view === "desktop") {
					ariaHidden[0].setAttribute("aria-hidden", "false");
					ariaExpanded[0].setAttribute("aria-expanded", "true");
				}

				if (plugin.settings.expandAllBtn && accordions.length > 1) toggleAllSetup();
			},

			/**
			 * Setup the accordion toggle button and aria attributes
			 *
			 * @function init
			 * @param {Object} options - User defined options
			 *
			 */
			init() {
				// If there are no accordions bail
				if (!plugin.element) return false;

				// Setup items in the DOM
				plugin.this.setup();

				// Add event mouse and keyboard listeners
				document.addEventListener("click", clickHandler, false);
				document.addEventListener("keydown", keyboardHandler, false);
			}
		};

		// Return the plugin
		return Plugin;
	}
);
